import * as joint from '../joint-plus/joint-plus.min.js'
import {isDefined} from './library'
import {arrayConvert} from './param-convert'
import {paramShapeConvert} from './param-shapes'

joint.shapes.diagram = {};

export const jointGetShape = type => {
  if (typeof type === 'undefined') {
    throw new Error('Type is not defined')
  }
  const typeParts = type.split(".")
  if (typeParts.length == 1) {
    if (typeParts[0] === 'Element') {
      return joint.dia.Element
    } else if (typeParts[0] === 'Link') {
      return joint.shapes.standard.Link
    }
  } else if (typeParts.length === 2) {
    const modelName = typeParts[0]
    const cellName = typeParts[1]
    if (joint.shapes[modelName]) {
      return joint.shapes[modelName][cellName]
    }
  }
}

export const jointCreateElement = (type, id) => {
  const shape = jointGetShape(type)
  return new shape({id})
}

const jointDefineLinkShape = paramShape => {
  const shape = paramShapeConvert(paramShape)
  const defaultPrototype = 'Link'
  const prototype = jointGetShape(shape.prototype || defaultPrototype)
  if (!prototype) {
    throw new Error(`Prototype ${shape.prototype} of shape ${shape.type} is not defined.`)
  }
  const {markup, ...rest} = shape 
  const prototypeProperties = { useCSSSelectors: true }
  if (isDefined(markup)) {
    prototypeProperties.markup = markup
  }
  const defaultInstanceProperties = rest
  prototype.define(shape.type, defaultInstanceProperties, prototypeProperties)
}

const jointDefineElementShape = paramShape => {
  const shape = paramShapeConvert(paramShape)
  const defaultPrototype = 'Element'
  const prototype = jointGetShape(shape.prototype || defaultPrototype)
  if (!prototype) {
    throw new Error(`Prototype ${shape.prototype} of shape ${shape.type} is not defined.`)
  }
  const {markup, ...rest} = shape 
  const prototypeProperties = { useCSSSelectors: true }
  if (isDefined(markup)) {
    prototypeProperties.markup = markup
  }
  const defaultInstanceProperties = rest
  prototype.define(shape.type, defaultInstanceProperties, prototypeProperties)
  var diagramElementView = joint.dia.ElementView.extend({
    onRender: function() {
      if (shape.flowConfig && shape.contentOperation) {
        var foreignObject = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
        if (this.el.childNodes.length > 1) {
          this.el.insertBefore(foreignObject, this.el.childNodes[1]);
        } else {
          this.el.appendChild(foreignObject);
        }
        var miniclientContainer = document.createElement('div');
        miniclientContainer.style.overflow = 'hidden auto';
        miniclientContainer.style.width = '100%';
        miniclientContainer.style.height = '100%';
        foreignObject.appendChild(miniclientContainer);
        var mnc = new Miniclient();
        mnc.config({element: miniclientContainer, configuration: shape.flowConfig, flowName: shape.contentOperation, lang: 'en', input: this.model.attributes, debug: false}).run()
      }
      return this;
    },
    confirmUpdate: function() {
      var flags = joint.dia.ElementView.prototype.confirmUpdate.apply(this, arguments);
      if (shape.flowConfig && shape.contentOperation) {
        var bbox = this.model.getBBox();
        var foreignObject = this.el.querySelector('foreignObject');
        foreignObject.setAttribute('width', bbox.width);
        foreignObject.setAttribute('height', bbox.height);
      }
    }
  });
  joint.util.setByPath(joint.shapes, shape.type + 'View', diagramElementView, '.');
}

const shapeDefine = (shape, isElement) => {
  if (!jointGetShape(shape.type)) {
    if (isElement) {
      jointDefineElementShape(shape)
    } else {
      jointDefineLinkShape(shape)
    }
  }
}

const shapesDefine = (shapes, isElement) => {
  shapes.forEach(shape => shapeDefine(shape, isElement))
}

export const jointDefineShapes = paramShapes => {
  shapesDefine(arrayConvert(paramShapes.link), false)
  shapesDefine(arrayConvert(paramShapes.element), true)
}

export const jointDefineElementShapes = paramElementShapes => {
  shapesDefine(arrayConvert(paramElementShapes), true)
}
